import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";

import $ from "jquery";
import yamljs from "yamljs";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";

import SideBarItem from "./SideBarItem";
import * as SidebarUtils from "../../Utils/SideBarUtils";
import * as Utils from "../../Utils/UIUtils";
import * as DocumentationConstant from "../../Constants/DocumentationConstant";
import * as DocumentationActions from "../../../middleware/Store/Actions/DocumentationActions";
import Spinner from "../../UI/Spinner/Spinner";
import DotSpinner from "../../UI/Spinner/DotSpinner";
import * as CustomEvents from "../../Constants/CustomEvents";

import "./SideBar.scss";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "DOCUMENTATION_MENU";
export const DOCUMENTATION_MENU_TAG = "DOCUMENTATION_DROPDOWN";
const BETA_TAG = "Beta";
const NEW_TAG = "New";
const LTS_NEW_TAG_LIST = [];
const STS_NEW_TAG_LIST = ["CSharp"];


const SideBarDocumentationMenu = (props) => {

    const [menuContent, setMenuContent] = useState([]);
    const [displayMenu, setDisplayMenu] = useState(null);
    const [newTagList, setNewTagList] = useState(LTS_NEW_TAG_LIST);
    const [progress, setProgress] = useState(true);

    const intl = useIntl();
    let location = useLocation();
    let debounceHandler = useRef(-1);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect displayMenu");
        if (!progress) {
            expandDocumentationMenuForPath(location.pathname);  // to open menu when new document path
            document.dispatchEvent(new Event(CustomEvents.CUSTOM_EVENT_SIDEBAR_MENU_UPDATE));
        }
    }, [displayMenu]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect", "documentationFilter");
        let file = DocumentationConstant.DocumentationLtsFile;
        setNewTagList(LTS_NEW_TAG_LIST);
        if (DocumentationConstant.DocumentationType.Sts === props.documentationFilter) {
            file = DocumentationConstant.DocumentationStsFile;
            setNewTagList(STS_NEW_TAG_LIST);
        }
        debounceHandler.current = SidebarUtils.debounce(() => loadContent(file), 300, debounceHandler.current);
    }, [props.documentationFilter]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect menuContent", "render sidebar");
        setDisplayMenu(getMenuDisplay());
    }, [menuContent]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location", "Path has changed:" + location.pathname);
        if (SidebarUtils.isDocumentationPath(location?.pathname)) {
            let docType = null;
            if (SidebarUtils.isStsDocumentation(location?.pathname))
                docType = DocumentationConstant.DocumentationType.Sts
            else if (SidebarUtils.isLtsDocumentation(location?.pathname)) //to avoid switch back to lts when sts and click on doc/hub, cli,...
                docType = DocumentationConstant.DocumentationType.Lts

            if (docType)
                props.setDocumentationFilter(docType);

            setTimeout(() => {//timeout needed because to near from closeDocumentationMenu
                expandDocumentationMenuForPath(location.pathname);  // to open menu when back (menu already loaded and same type)
            }, 300);
        } else {
            closeDocumentationMenu();
        }
    }, [location]);

    const loadContent = (fileName) => {
        LogService.info(LOG_TAG, "loadContent file:" + fileName);

        setProgress(true);

        try {
            let ymlObj = yamljs.load(fileName);
            SidebarUtils.getContent(ymlObj)
                .then((content) => {
                    setMenuContent(content);
                    setProgress(false);
                });
        } catch (error) {
            LogService.error(LOG_TAG, "loadContent error during load", error);
            setMenuContent([]);
            setProgress(false);
        }
    }

    const expandDocumentationMenuForPath = (documentationPath) => {
        LogService.trace(LOG_TAG, "expandMenuForSideBarItem:", documentationPath);

        const sideBarParentElements = SidebarUtils.findDocumentationPathInMenu(documentationPath);
        sideBarParentElements.each(function () {
            $(this).children().each(function () {
                if ($(this).hasClass("collapse") || $(this).hasClass("collapsing")) {
                    $(this).collapse("show");
                }
            });
        });
    }

    const closeDocumentationMenu = () => {
        LogService.trace(LOG_TAG, "closeDocumentationMenu");
        $("#" + DOCUMENTATION_MENU_TAG).find(".collapse").collapse("hide");
    }

    //render SubMenu
    const getSubMenuDisplay = (content, collapseClass) => {
        let index = 0;
        index = index + 1;
        const myTarget = "header-" + collapseClass + index;
        const menuContentDisplay = content?.map((item, i) => {
            const childCollapseClass = collapseClass + i;

            let subMenuDisplay = null;
            if (item.content) {
                if (item.content.length === 0) {//case empty submenu => Home?!
                    return (
                        <SideBarItem key={i} to={item.to ? item.to : ""} >
                            <FontAwesomeIcon icon={faMinus} className="sidebar-bullet text-primary" />
                            <span>{item.label}</span>
                        </SideBarItem>
                    );
                } else {//current case Menu Level2
                    subMenuDisplay = getSubMenuDisplay(item.content, childCollapseClass);
                    const mySubHeading = "subheading" + i;
                    let betaBadge = item.isChildBeta;

                    return (
                        <div key={i} id="subMenu">
                            <li>
                                <a
                                    id={mySubHeading}
                                    data-toggle="collapse"
                                    data-target={"#" + childCollapseClass}
                                    aria-controls={childCollapseClass}
                                    className="sidebar-link collapsed"
                                >
                                    <FontAwesomeIcon icon={faMinus} className="sidebar-bullet text-primary" />
                                    <span>{item.label}</span>
                                    {betaBadge && <span className="badge badge-pink position-absolute end-5" style={{ top: "7px" }}>{BETA_TAG}</span>}
                                </a>

                                <div key={i} id={childCollapseClass} aria-labelledby={mySubHeading} data-parent={"#" + myTarget} className="collapse">
                                    {subMenuDisplay}
                                </div>
                            </li>
                        </div>
                    );
                }
            } else {
                return ( //Menu Level 3
                    <SideBarItem key={i} to={item.to} externalLink={item.externalLink}><span>{item.label}</span></SideBarItem>
                );
            }
        });

        return (<ul id={myTarget} className="sidebar-dropdown">{menuContentDisplay}</ul>)
    }

    //render Menu (level 1)
    const getMenuDisplay = () => {
        LogService.trace(LOG_TAG, "getMenuDisplay");

        let menuDisplay = null;
        const menuTitleDisplay = <li key="header0" className="sidebar-header"> {intl.messages.menuHeaderDocumentation} </li>
        if (menuContent?.length > 0) {
            const menuContentDisplay = menuContent.map((item, i) => {
                let icon = Utils.getIcon(item.icon);

                let subMenuDisplay = null;
                if (item.content && item.content.length > 0) {
                    let childCollapseClass = item.label + "_" + i;
                    childCollapseClass = childCollapseClass.replace(/ /g, "");
                    subMenuDisplay = getSubMenuDisplay(item.content, childCollapseClass);

                    let betaBadge = item.isChildBeta;
                    let newBadge = false;
                    if (newTagList.some(name => name === item.label)) {
                        newBadge = true;
                    }

                    const myHeading = "heading" + i;

                    return (
                        <ul key={i} className="p-0">
                            <li>
                                <a
                                    id={myHeading}
                                    className="sidebar-link collapsed"
                                    data-toggle="collapse"
                                    data-target={"#" + childCollapseClass}
                                    aria-expanded="false"
                                    aria-controls={childCollapseClass}
                                >
                                    <FontAwesomeIcon icon={icon} fixedWidth className="mr-2" />
                                    <span>{item.label}</span>
                                    {betaBadge && <span className="badge badge-pink position-absolute end-5" style={{ top: "13px" }}>{BETA_TAG}</span>}
                                    {newBadge && <span className="badge badge-new position-absolute end-5" style={{ top: "13px" }}>{NEW_TAG}</span>}
                                </a>

                                <div id={childCollapseClass} className="collapse"
                                    aria-labelledby={myHeading} data-parent={"#" + DOCUMENTATION_MENU_TAG}>
                                    {subMenuDisplay}
                                </div>
                            </li>
                        </ul>
                    );
                } else { //case top menu with no submenu
                    return (
                        <SideBarItem key={i} to="">
                            <FontAwesomeIcon icon={icon} fixedWidth className="mr-2" />
                            <span>{item.label}</span>
                        </SideBarItem>
                    );
                }
            });
            menuDisplay = <div id={DOCUMENTATION_MENU_TAG}>
                {menuTitleDisplay}
                {menuContentDisplay}
            </div>
        } else if (progress) {
            menuDisplay = <div id={DOCUMENTATION_MENU_TAG} className="row ml-0 mr-0">
                {menuTitleDisplay}
                <DotSpinner />
            </div>
        }
        return menuDisplay;
    }

    LogService.info(LOG_TAG, "render");
    return displayMenu;
}

const mapStateToProps = state => {
    return {
        documentationFilter: state.documentation.filter
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setDocumentationFilter: (value) => dispatch(DocumentationActions.setDocumentationFilter(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBarDocumentationMenu);